export function parseApiErrorMessage(message: string): string {
    try {
        // Try to extract JSON part from the message (e.g. 400: {"detail":"..."})
        const match = message.match(/{.*}/);
        if (match) {
            const parsed = JSON.parse(match[0]);
            if (parsed.detail) return parsed.detail; // use API's detail field
        }
        return message; // fallback to full message
    } catch {
        return message; // fallback if parsing fails
    }
}